import {
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import {
  USER_LICENSES_CARD_NAME,
  USER_LICENSES_ENTITY_KIND_FILTER,
  USER_LICENSES_PLUGIN_ID,
} from '@ns/plugin-ns-tessa-common';

const userLicensesCard = EntityCardBlueprint.make({
  name: USER_LICENSES_CARD_NAME,
  params: {
    filter: { kind: USER_LICENSES_ENTITY_KIND_FILTER },
    loader: () =>
      import('./components/user-licenses-card/user-licenses-card').then(m => (
        <m.UserLicensesCard />
      )),
    type: 'content',
  },
});

const currentUserLicensesCard = EntityCardBlueprint.make({
  name: 'my-licenses',
  params: {
    filter: { kind: USER_LICENSES_ENTITY_KIND_FILTER },
    loader: () =>
      import(
        './components/current-user-licenses-card/current-user-licenses-card'
      ).then(module => <module.CurrentUserLicensesCard />),
    type: 'content',
  },
});

/**
 * Annotated rather than inferred: without it TypeScript wants to name the
 * inferred type through `@backstage/core-plugin-api`'s nested copy of
 * `@backstage/frontend-plugin-api`, which is not a portable path (TS2742). The
 * annotation only surfaces once this package is type-checked directly, which is
 * what the `plugins/ns-tessa/ns-tessa-user-licenses/src` entry in the root
 * tsconfig now does — and which is what makes the type contracts in this
 * plugin's tests enforced rather than decorative.
 */
const userLicensesPlugin: FrontendPlugin = createFrontendPlugin({
  extensions: [userLicensesCard, currentUserLicensesCard],
  pluginId: USER_LICENSES_PLUGIN_ID,
});

export default userLicensesPlugin;

export { UserLicensesCard } from './components/user-licenses-card/user-licenses-card';
